<p>{{type | reminderNameTypePipe}}</p>
